/**
 * Date utility functions for stock closing operations
 */

export function toLocalDateOnly(d: Date): Date {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate());
}

export function parseToDate(v: string | Date): Date | null {
  if (!v) return null;
  if (v instanceof Date) return v;
  if (/^\d{4}-\d{2}-\d{2}$/.test(v)) {
    const [y, m, d] = v.split("-").map(Number);
    return new Date(y, m - 1, d);
  }
  const d2 = new Date(v);
  return isNaN(d2.getTime()) ? null : d2;
}

export function daysBetween(a: Date, b: Date): number {
  const MS = 24 * 60 * 60 * 1000;
  return Math.round(
    (toLocalDateOnly(b).getTime() - toLocalDateOnly(a).getTime()) / MS
  );
}
